import _slicedToArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { useCallback, useEffect, useState, createContext, useContext, useMemo } from 'react';
import { useAtom } from 'jotai';
import { atomWithStorage, RESET } from 'jotai/utils';
import { useNavigationContext } from './navigation-context';
import { jsx as _jsx } from "react/jsx-runtime";
var UTMSourceContext = /*#__PURE__*/createContext({
  utmSource: null,
  refCode: null,
  partnerCode: null,
  removeRefCode: function removeRefCode() {
    return null;
  },
  removeUtmSource: function removeUtmSource() {
    return null;
  },
  removePartnerCode: function removePartnerCode() {
    return null;
  }
});
var UTM_SOURCE_STORAGE_KEY = 'utm_source';
var PARTNER_CODE_STORAGE_KEY = 'partner_code';
var utmSourceAtom = atomWithStorage(UTM_SOURCE_STORAGE_KEY, null);
var partnerCodeAtom = atomWithStorage(PARTNER_CODE_STORAGE_KEY, null);

var UTMSourceProvider = function UTMSourceProvider(_ref) {
  var children = _ref.children;

  var _useAtom = useAtom(utmSourceAtom),
      _useAtom2 = _slicedToArray(_useAtom, 2),
      utmSource = _useAtom2[0],
      setUtmSource = _useAtom2[1];

  var _useAtom3 = useAtom(partnerCodeAtom),
      _useAtom4 = _slicedToArray(_useAtom3, 2),
      partnerCode = _useAtom4[0],
      setPartnerCode = _useAtom4[1];

  var _useState = useState(null),
      refCode = _useState[0],
      setRefCode = _useState[1];

  var _useNavigationContext = useNavigationContext(),
      router = _useNavigationContext.router;

  var query = router === null || router === void 0 ? void 0 : router['query'];
  var queryRefCode = query === null || query === void 0 ? void 0 : query.ref_code;
  var queryUtmSource = query === null || query === void 0 ? void 0 : query.utm_source;
  var queryPartner = query === null || query === void 0 ? void 0 : query.partner;
  var events = router === null || router === void 0 ? void 0 : router.events;
  var isRouteReady = router === null || router === void 0 ? void 0 : router.isReady;
  var isQueryUTMSourceValid = useMemo(function () {
    return typeof queryUtmSource === 'string' && !!queryUtmSource;
  }, [queryUtmSource]);
  var isQueryPartnerValid = useMemo(function () {
    return typeof queryPartner === 'string' && !!queryPartner;
  }, [queryPartner]);
  var saveUTMSource = useCallback(function () {
    if (!isQueryUTMSourceValid) return;
    if (queryUtmSource) setUtmSource(queryUtmSource);
  }, [isQueryUTMSourceValid, queryUtmSource, setUtmSource]);
  var savePartnerCode = useCallback(function () {
    if (!isQueryPartnerValid) return;
    if (typeof queryPartner === 'string') setPartnerCode(queryPartner);
  }, [isQueryPartnerValid, queryPartner, setPartnerCode]);
  var saveReferralCode = useCallback(function () {
    var urlRefCode = queryRefCode && Array.isArray(queryRefCode) ? queryRefCode[0] : queryRefCode;
    var localstorageRefCode = window.localStorage.getItem('ref_code');

    if (urlRefCode) {
      window.localStorage.setItem('ref_code', urlRefCode);
      setRefCode(urlRefCode);
    } else if (localstorageRefCode) {
      setRefCode(localstorageRefCode);
    }
  }, [queryRefCode]);
  useEffect(function () {
    if (!events) return;
    events.on('routeChangeStart', saveUTMSource);
    events.on('routeChangeStart', savePartnerCode);
    return function () {
      events.off('routeChangeStart', saveUTMSource);
      events.off('routeChangeStart', savePartnerCode);
    };
  }, [events, saveUTMSource, savePartnerCode]);
  useEffect(function () {
    if (isRouteReady) {
      saveUTMSource();
      savePartnerCode();
      saveReferralCode();
    }
  }, [isRouteReady, saveUTMSource, savePartnerCode, saveReferralCode]);
  var removeRefCode = useCallback(function () {
    window.localStorage.removeItem('ref_code');
    setRefCode(null);
  }, []);
  var removeUtmSource = useCallback(function () {
    setUtmSource(RESET);
  }, [setUtmSource]);
  var removePartnerCode = useCallback(function () {
    setPartnerCode(RESET);
  }, [setPartnerCode]);
  return /*#__PURE__*/_jsx(UTMSourceContext.Provider, {
    value: {
      utmSource: utmSource,
      refCode: refCode,
      partnerCode: partnerCode,
      removeRefCode: removeRefCode,
      removeUtmSource: removeUtmSource,
      removePartnerCode: removePartnerCode
    },
    children: children
  });
};

var useUTMSource = function useUTMSource() {
  var context = useContext(UTMSourceContext);
  if (!context) throw new Error('useUTMSource must be used within a UTMSourceContext');
  return useMemo(function () {
    return context;
  }, [context]);
};

export { UTMSourceProvider, useUTMSource };